<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-block`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.87 9.96L24.855 1.413a2 2 0 00-1.715 0L5.155 9.96a2 2 0 00-1.142 1.806v22.463a2 2 0 001.14 1.806l17.985 8.564a2 2 0 001.72 0l18.014-8.564a2 2 0 001.14-1.806V11.765A2 2 0 0042.87 9.96zM8.013 32.964L8.012 15.56l13.85 6.953.037.018.26 17.171-14.146-6.736zm32-17.409L26.036 22.52l-.135.061.256 16.971 13.856-6.587V15.556zm-30.01-3.474l13.996-6.647 14.017 6.648-13.763 6.855a.667.667 0 01-.597 0l-13.653-6.856z"/></svg>
</template>
<script>

export default {
  name: 'IconBlock',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
